import { render, staticRenderFns } from "./LogScreen.vue?vue&type=template&id=335e866e&scoped=true"
import script from "./LogScreen.vue?vue&type=script&lang=js"
export * from "./LogScreen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "335e866e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/brkt/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('335e866e')) {
      api.createRecord('335e866e', component.options)
    } else {
      api.reload('335e866e', component.options)
    }
    module.hot.accept("./LogScreen.vue?vue&type=template&id=335e866e&scoped=true", function () {
      api.rerender('335e866e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/app/pages/LogScreen.vue"
export default component.exports